module.exports = __webpack_public_path__ + "img/poland.31513ffc.svg";